import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../user.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(
    private router: Router,
    private userService: UserService,
    private translate: TranslateService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree | Observable<boolean | UrlTree>> {
    // console.log('[AUTH GUARD] START');

    localStorage.removeItem('userRole');

    let user = await this.userService.getCurrentUser();
    // console.log('[AUTH GUARD]  is logged:', user);

    if (!user) {
      // console.log('[AUTH GUARD] Trying login with token');

      const success = await this.userService.tryToLogin(
        route.queryParams['token'],
        route.queryParams['rt']
      );

      if (success) {
        // console.log('[AUTH GUARD] Successfully logged in using RT', success);
        user = await this.userService.getCurrentUser();
      } else {
        // console.log('[AUTH GUARD] log in unsuccessful', success);
        return this.router.createUrlTree(['/auth/login'], { queryParams: { redirect: state.url } });
      }
    }

    // console.log('[AUTH GUARD] User', user);
    if (!user) {
      return false;
    }

    const userLanguage = user.language?.toLocaleLowerCase() || 'en';
    this.translate.use(userLanguage);
    console.log('[AUTH GUARD] [Language] set to:', userLanguage);

    const module = state.url.split('/')[1].split('?')[0];

    // console.log('[AUTH GUARD] Module', module);

    console.log('[AUTH GUARD] Checking module:', module, '| Role:', user?.primary_role, '| URL:', state.url);

    switch (module.toLowerCase()) {
      case 'client': {
        if (user?.primary_role == 'CLIENT') {
          console.log('[AUTH GUARD] CLIENT accessing /client - ALLOWED');
          return true;
        } else {
          // Redirecionar para landing page correta baseada no role
          console.log('[AUTH GUARD] Non-CLIENT trying /client - Redirecting to role landing page');
          this.redirectToRoleLandingPage(user?.primary_role);
          return true;
        }
      }
      case 'firm': {
        if (user?.primary_role === 'AGENT' && user.attributes?.agent_partner === true) {
          console.log('[AUTH GUARD] AGENT PARTNER BLOCKED from Firm Portal', user.id);
          await this.userService.signOut();
          return this.router.createUrlTree(['/auth/login']);
        }

        if (
          user?.primary_role == 'ADMINISTRATOR' ||
          user?.primary_role == 'AGENT' ||
          user?.primary_role == 'CO-COUNSEL' ||
          user?.primary_role == 'FUNDER'
        ) {
          // Se está entrando em /firm pela primeira vez, redirecionar para landing page correta
          if (state.url === '/firm' || state.url === '/firm/') {
            console.log('[AUTH GUARD] Entering /firm root - Redirecting', user?.primary_role, 'to landing page');
            this.redirectToRoleLandingPage(user?.primary_role);
            return false;
          }
          console.log('[AUTH GUARD] FIRM user accessing', state.url, '- ALLOWED');
          return true;
        } else {
          console.log('[AUTH GUARD] Non-FIRM role trying /firm - Redirecting to /client');
          this.router.navigate(['/client']);
          return true;
        }
      }

      default: {
        console.log(
          '[AUTH GUARD] Module does not support authentication',
          module
        );

        return false;
      }
    }
  }

  /**
   * Redireciona o usuário para sua landing page correta baseada no role
   */
  private redirectToRoleLandingPage(role: string | undefined): void {
    let targetUrl: string;

    switch (role) {
      case 'ADMINISTRATOR':
        targetUrl = '/firm/cases';
        break;
      case 'AGENT':
        targetUrl = '/firm/agent-dashboard';
        break;
      case 'CO-COUNSEL':
        targetUrl = '/firm/cocounsel/claims';
        break;
      case 'FUNDER':
        targetUrl = '/firm/funder/dashboard';
        break;
      case 'CLIENT':
      default:
        targetUrl = '/client';
        break;
    }

    console.log('[AUTH GUARD] redirectToRoleLandingPage:', role, '->', targetUrl);
    this.router.navigate([targetUrl]);
  }
}
